import React from 'react'
import { motion } from 'framer-motion'
import { projectFirestore } from '../firebase/config'

const Modal = ({ selectedImg, setSelectedImg }) => {

    const deleteClickHandler = async (selectedImg) => {
        console.log(selectedImg.id)
        setSelectedImg(null)
        await projectFirestore.collection('images').doc(selectedImg.id).delete();
    }

    const handleClick = (e) => {
        if(e.target.classList.contains('backdrop')){
            setSelectedImg(null)
        }
    }

  return (
    <motion.div className='backdrop' onClick={handleClick}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
    >
         <motion.img src={selectedImg.url} alt='enlarged image' 
            initial={{ y: '-10vh'}}
            animate={{ y: 0 }}
         />
         <div className='menu'>
            <div className='delete' onClick={() => deleteClickHandler(selectedImg)}>Delete 🗑</div>
            <br/>
            <a className='download' download target="_blank" href={selectedImg.url}>Download ⬇️ </a>
         </div>
    </motion.div>
  )
}

export default Modal;